<!-- ── Legend : one radio per metric, tolerance bar + bucket counts under the selected one ── -->
<aside class="holes-view__legend" data-attr="holes-legend-quality">
  <app-holes-legend-panel>
    <div class="quality-legend">

      @if (state.toleranceError()) {
        <div class="quality-legend__notice quality-legend__notice--error">
          <span>{{ 'HOLES_TAB.QUALITY_TOLERANCE_ERROR' | translate }}</span>
          @if (canConfigureSite) {
            <button type="button" class="quality-legend__retry" (click)="openToleranceSettings()"
              data-attr="holes-quality-tolerance-settings">{{ 'HOLES_TAB.QUALITY_TOLERANCE_SETTINGS' | translate }}</button>
          } @else {
            <button type="button" class="quality-legend__retry" (click)="retryTolerance()">{{ 'HOLES_TAB.RETRY' | translate }}</button>
          }
        </div>
      }

      @for (item of legendMetrics(); track item.metric.id) {
        <div class="quality-legend__metric" [class.quality-legend__metric--active]="metricId() === item.metric.id">
          <app-radiobox
            size="small"
            [options]="item.option"
            [ngModel]="metricId()"
            (ngModelChange)="onMetricChange($event)"
            [attr.data-attr]="'holes-quality-metric-' + item.metric.id.toLowerCase()">
          </app-radiobox>

          @if (metricId() === item.metric.id) {
            <div class="quality-legend__details">
              @if (item.metric.id === 'POWDER_FACTOR') {
                <!-- No site tolerance: dynamic scale over the blast's values -->
                @if (powderFactorScale(); as scale) {
                  <div class="quality-scale" data-attr="holes-quality-pf-scale">
                    <div class="quality-scale__track"
                      [style.background]="'linear-gradient(90deg, ' + scaleColors.low + ', ' + scaleColors.mid + ', ' + scaleColors.high + ')'"></div>
                    <div class="quality-scale__values">
                      <span>{{ scale.min | number:'1.2-2' }}</span>
                      <span>{{ scale.mid | number:'1.2-2' }}</span>
                      <span>{{ scale.max | number:'1.2-2' }}</span>
                    </div>
                    <div class="quality-scale__labels">
                      <span>{{ 'HOLES_TAB.QUALITY_PF_UNDER_LOADED' | translate }}</span>
                      <span>{{ 'HOLES_TAB.QUALITY_PF_OVER_LOADED' | translate }}</span>
                    </div>
                  </div>
                } @else if (state.loading() && !state.loadingError()) {
                  <p class="quality-legend__empty">{{ 'HOLES_TAB.QUALITY_PF_NO_VALUES' | translate }}</p>
                }
              } @else if (item.threshold; as threshold) {
                <app-tolerance-bar
                  class="quality-legend__bar"
                  [readOnly]="true"
                  [showNegative]="hasNegativeSide(threshold)"
                  [asDesignedMax]="threshold.asDesignedMax"
                  [inToleranceMax]="threshold.inToleranceMax"
                  [asDesignedMin]="threshold.asDesignedMin ?? 0"
                  [inToleranceMin]="threshold.inToleranceMin ?? 0" />
              } @else if (!state.toleranceLoading() && !state.toleranceError()) {
                <p class="quality-legend__empty">{{ 'HOLES_TAB.QUALITY_NOT_CONFIGURED' | translate }}</p>
              }

              @if (item.metric.source === 'loading' && state.loadingError()) {
                <div class="quality-legend__notice quality-legend__notice--error">
                  <span>{{ 'HOLES_TAB.QUALITY_LOADING_ERROR' | translate }}</span>
                  <button type="button" class="quality-legend__retry" (click)="retryLoading()">{{ 'HOLES_TAB.RETRY' | translate }}</button>
                </div>
              }

              <ul class="quality-legend__counts" data-attr="holes-quality-counts">
                @for (count of bucketCounts(); track count.bucket) {
                  <li class="quality-legend__count">
                    <span class="quality-legend__swatch" [style.background]="count.color"></span>
                    <span class="quality-legend__count-label">{{ count.label }}</span>
                    <span class="quality-legend__count-value">{{ count.count }}</span>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }

    </div>
  </app-holes-legend-panel>
</aside>

<!-- ── Panel : per-hole quality table ───────────────────────────────────────── -->
<section class="holes-view__panel" data-attr="holes-panel-quality">

  <!-- One ring chip per metric with values: as designed / in tolerance / out of spec, short name beside it -->
  <div class="holes-view__head">
    @if (metricRings().length) {
      <div class="quality-panel__rings" data-attr="holes-quality-rings">
        @for (ring of metricRings(); track ring.metricId) {
          <app-progress-chip
            [segments]="ring.segments"
            [label]="ring.label"
            [title]="ring.title"
            [active]="metricId() === ring.metricId"
            [clickable]="true"
            (pressed)="onMetricChange(ring.metricId)"
            [attr.data-attr]="'holes-quality-ring-' + ring.metricId.toLowerCase()" />
        }
      </div>
    }
    <div class="holes-view__columns">
      <app-button-list
        [items]="allColumns()"
        [selectedKeys]="visibleColumnKeys()"
        (selectionChange)="onColumnsChange($event)"
        iconSrc="assets/icon/settings.svg"
        panelTitle="QAQC_TAB.COLUMNS" />
    </div>
  </div>

  <div class="holes-view__table">

    @if (rows().length) {
      <app-data-table
        [data]="rows()"
        [columns]="visibleColumns()"
        [searchTerm]="state.searchTerm()"
        [clickable]="true"
        rowKey="publicGuid"
        highlightedRowKey="publicGuid"
        [highlightedRowValue]="state.selectedHoleId()"
        (selectionLigne)="onRowClick($event)"
        sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
        sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
        sortIconFilter="brightness(0)" />
    } @else if (!state.isLoading()) {
      <p class="holes-view__empty">{{ 'HOLES_TAB.NO_HOLES' | translate }}</p>
    }
  </div>

</section>
